import React, { Component } from 'react';
import { connect } from 'react-redux';

import { createCarousel } from '../actions/CarouselActions';

import { Pane, Heading, Button } from 'evergreen-ui';
import InfoBlock from '../../common/InfoBlock/InfoBlock';

import { Link } from 'react-router-dom';
import CarouselForm from '../components/CarouselForm';

import Configuration from '../Config';

const validation = Configuration.Validations.carousel;
const defaultValues = Configuration.Defaults.createCarousel;
const mapValidationErrors = Configuration.ErrorHandler.mapValidationErrors;

class CreateCarousel extends Component {
    componentDidMount() {
       
    }

    handleSave = (values) => {
        this.props.dispatch(createCarousel(values));
    }

    render() {
        return (
            <Pane padding={16} paddingTop={0}>
                <Pane display="flex">
                    <Pane>
                        <Link to="/carousel">
                            <Button iconBefore="arrow-left" intent="none">
                                Inapoi la lista carusel
                            </Button>
                        </Link>
                    </Pane>
                </Pane>

                <Pane flex={1} background="tint1" elevation={1} padding={16} marginTop={16}>
                    <Heading size={600}>
                        Slide nou
                    </Heading>
                </Pane>
                
                <Pane display="flex" justifyContent="space-between" flex={1} marginTop={16}>
                    <InfoBlock flex="1">
                        <CarouselForm 
                            isEdit={false}
                            initialValues={defaultValues}
                            validationSchema={validation}
                            onSave={this.handleSave}
                            errors={this.props.errors}/>
                    </InfoBlock>
                </Pane>

            </Pane>
        )
    }
}

function mapStateToProps(state) {
    return {
        errors: state.carousel.errors.type === 'validation' ? mapValidationErrors(state.carousel.errors.fields): [],
    }
}

export default connect(mapStateToProps)(CreateCarousel);